import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import { RootState } from '../../../redux/store';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import CustomSwitch from '../../../components/CustomSwitch';
import { ilkOtomatikFaturaListIstegi, OTOMATIK_FATURA_SAYFASI, OtomatikFaturaKurali, OtomatikFaturaListIstegi, OtomatikFaturaService } from '../../../services/OtomatikFaturaService';
import OtomatikFaturaListFilters from './Components/OtomatikFaturaListFilters';
import KopyalaModal from './Components/KopyalaModal';

/**
 * Ayarlar > Otomatik Faturalama: kurallar (standart liste ekranı, 22.10.2026). Her kural cron zamanında dönemini
 * faturalar; "Aktif" anahtarı listeden açılıp kapatılır (pasif kural çalışmaz, ayarları ve geçmişi durur).
 */
const OtomatikFaturaList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = OTOMATIK_FATURA_SAYFASI
    const pageVersion = "1";
    const [data, setData] = useState<{ list: OtomatikFaturaKurali[], totalRecordCount: number }>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<OtomatikFaturaListIstegi>(ilkOtomatikFaturaListIstegi)
    const [kopyalanacak, setKopyalanacak] = useState<OtomatikFaturaKurali | undefined>(undefined);
    const guncelleyebilir = !!auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canUpdate;

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Kural', name: 'ad', order: 0, isVisible: true },
            { title: 'Modül', name: 'modulAdi', order: 0, isVisible: true },
            { title: 'Tür', name: 'kuralTuruAdi', order: 0, isVisible: true },
            { title: 'Zamanlama', name: 'cron', order: 0, isVisible: true },
            { title: 'Başlangıç', name: 'baslangicTarihi', order: 0, isVisible: true },
            { title: 'Bitiş', name: 'bitisTarihi', order: 0, isVisible: true },
            { title: 'Müşteriler', name: 'musteriler', order: 0, isVisible: true },
            { title: 'PO Numaraları', name: 'poNumaralariAdi', order: 0, isVisible: true },
            { title: 'Gönderim', name: 'gonderimAdi', order: 0, isVisible: true },
            { title: 'Onay', name: 'onaylayiciAdi', order: 0, isVisible: true },
            { title: 'Sonraki Çalışma', name: 'sonrakiCalismaStr', order: 0, isVisible: true },
            { title: 'Son Durum', name: 'sonDurumAdi', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });

    const changeTake = (_take: number) => getData({ ...filter, currentPage: 1, skip: 0, take: _take });

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const updateKural = async (_id: string | undefined = undefined) => {
        navigate('/otomatikfatura/listadd?id=' + (_id ? _id : data.list.filter(x => x.isSelected)[0].otomatikFaturaKuraliId));
    }

    const deleteKural = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await OtomatikFaturaService.sil(data.list.filter(x => x.isSelected).map(x => x.otomatikFaturaKuraliId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success('Seçilen kurallar silindi.')

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const aktiflikDegistir = async (item: OtomatikFaturaKurali) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await OtomatikFaturaService.aktiflik(item.otomatikFaturaKuraliId, !item.isCustomActive);

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            toast.success(item.isCustomActive ? 'Kural pasif yapıldı.' : 'Kural aktif yapıldı.')

            getData();
        } catch (error: any) {
            toast.error(error)
        } finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: OtomatikFaturaListIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response = await OtomatikFaturaService.getList(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data ?? { list: [], totalRecordCount: 0 });
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            list: data.list.map(function (x) {
                if (x.otomatikFaturaKuraliId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.list.length == data.list.filter(x => x.isSelected).length;

        setData({
            ...data,
            list: data.list.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await OtomatikFaturaService.exportList(buildExcelRequest(filter, mode, data.list.filter(x => x.isSelected).map(x => x.otomatikFaturaKuraliId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon adları backend'deki eşlemeyle (OtomatikFaturaListe) aynı.
    const sortableColumns = ['ad', 'modulAdi', 'kuralTuruAdi', 'isCustomActive', 'baslangicTarihi', 'bitisTarihi', 'gonderimAdi', 'onaylayiciAdi', 'sonrakiCalismaStr', 'sonDurumAdi'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        isCustomActive: YES_NO_FILTER,
        ad: { type: 'text' },
        modulAdi: { type: 'text' },
        kuralTuruAdi: { type: 'text' },
        cron: { type: 'text' },
        baslangicTarihi: { type: 'date' },
        bitisTarihi: { type: 'date' },
        musteriler: { type: 'text' },
        poNumaralariAdi: { type: 'text' },
        gonderimAdi: { type: 'text' },
        onaylayiciAdi: { type: 'text' },
        sonrakiCalismaStr: { type: 'date' },
        sonDurumAdi: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: OtomatikFaturaKurali, column: string, className: string | undefined) => {
        if (column == "isCustomActive")
            return (
                <td className={className} title={guncelleyebilir ? 'Açıp kapatmak için tıklayın' : undefined}>
                    <CustomSwitch isActive={item.isCustomActive} setIsActive={guncelleyebilir ? () => aktiflikDegistir(item) : () => { }} />
                </td>
            );

        var item2: any = item;
        var deger = item2[column];

        if (column == "cron")
            deger = <span style={{ fontFamily: 'monospace' }}>{item.cron}</span>;

        return <td className={className} onClick={() => setItemSelected(item.otomatikFaturaKuraliId)} onDoubleClick={() => updateKural(item.otomatikFaturaKuraliId)}>{deger}</td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <OtomatikFaturaListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    setFilter={setFilter}
                    selectedCount={data.list.filter(x => x.isSelected).length}
                    onSearchSubmit={onSearchSubmit}
                    deleteFunction={deleteKural}
                    updateFunction={updateKural}
                    copyFunction={() => setKopyalanacak(data.list.filter(x => x.isSelected)[0])}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.list.length > 0 && data.list.filter(x => x.isSelected).length == data.list.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item) =>
                                            <tr key={item.otomatikFaturaKuraliId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.otomatikFaturaKuraliId)} className='form-check-input' type='checkbox' checked={!!item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.list.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>

            <KopyalaModal
                kural={kopyalanacak}
                onClose={() => setKopyalanacak(undefined)}
                onKopyalandi={(id, ayniFirma) => { setKopyalanacak(undefined); if (ayniFirma) navigate('/otomatikfatura/listadd?id=' + id); else getData(); }}
            />
        </React.Fragment>
    )
}

export default OtomatikFaturaList;
